import {useContext} from 'react'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import {BadgeProductsContext} from '../../context'

const DeleteProductBadgeModal = ({products, onClose}: {products: any; onClose: () => void}) => {
  const {deleteProductBadge, isOperationLoading, isLoading} = useContext(BadgeProductsContext)

  return (
    <ConfirmationModal
      show={true}
      onClose={onClose}
      onAction={() => deleteProductBadge(products?.map((product: any) => product.id))}
      isOperationLoading={isOperationLoading}
      isDataLoading={isLoading}
      body={
        <>
          <p className='mb-2'>
            Do you really want to delete{' '}
            <strong>{products?.map((product: any) => product.sku).join(', ')}</strong> product?
          </p>
          <p>This action is irreversible and will remove product from related badge.</p>
        </>
      }
    />
  )
}
export default DeleteProductBadgeModal
